/**
 * description: 选择音频的弹出框
 * created by liu jinming
 * created on 2017.09.28
 */
"use strict";
angular.module('trsGetHistoryVideoServiceModule', ["trsGetHistoryVideoModule"])
    .factory('trsGetHistoryVideoService', ["$modal", "trsHttpService", "$timeout", "modalDialog", "$sce",
        function($modal, trsHttpService, $timeout, modalDialog, $sce) {
            return {
                getHistoryVideo: function(videoId, success, cancel) {
                    var modalInstance = $modal.open({
                        templateUrl: "./components/service/trsGetHistoryVideo/trsGetHistoryVideo_tpl.html",
                        windowClass: 'historyVideo',
                        backdrop: false,
                        controller: "trsGetHistoryVideoCtrl",
                        resolve: {
                            videoId: function() {
                                return videoId;
                            }
                        }
                    });
                    return modalInstance.result.then(function(data) {
                        if (data == "cancel") {
                            if (angular.isFunction(cancel)) {
                                cancel(data);
                            }
                        } else {
                            if (angular.isFunction(success)) {
                                success(data);
                            }
                        }
                    });
                }
            };
        }
    ]);